export const pricePeriods = {
  room1: [
    { start: 0, end: 2, price: 120 }, // Gennaio - Marzo
    { start: 3, end: 5, price: 140 }, // Aprile - Giugno
    { start: 6, end: 7, price: 150 }, // Luglio - Agosto
    { start: 8, end: 8, price: 140 }, // Settembre
    { start: 9, end: 9, price: 120 }, // Ottobre
    { start: 10, end: 10, price: 100 }, // Novembre
    { start: 11, end: 11, price: 130 }, // Dicembre
  ],
  room2: [
    { start: 0, end: 2, price: 100 },
    { start: 3, end: 5, price: 120 },
    { start: 6, end: 7, price: 130 },
    { start: 8, end: 8, price: 120 },
    { start: 9, end: 10, price: 100 },
    { start: 11, end: 11, price: 120 },
  ],
  room3: [
    { start: 0, end: 2, price: 90 },
    { start: 3, end: 5, price: 110 },
    { start: 6, end: 7, price: 120 },
    { start: 8, end: 8, price: 110 },
    { start: 9, end: 9, price: 100 },
    { start: 10, end: 10, price: 90 },
    { start: 11, end: 11, price: 120 },
  ],
  room4: [
    { start: 0, end: 1, price: 80 },
    { start: 2, end: 2, price: 90 },
    { start: 3, end: 3, price: 100 },
    { start: 4, end: 5, price: 110 },
    { start: 6, end: 7, price: 120 },
    { start: 8, end: 8, price: 110 },
    { start: 9, end: 9, price: 100 },
    { start: 10, end: 10, price: 80 },
    { start: 11, end: 11, price: 110 },
  ],
  room5: [
    { start: 0, end: 2, price: 90 },
    { start: 3, end: 5, price: 110 },
    { start: 6, end: 7, price: 120 },
    { start: 8, end: 8, price: 110 },
    { start: 9, end: 9, price: 100 },
    { start: 10, end: 10, price: 90 },
    { start: 11, end: 11, price: 120 },
  ],
};
